import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { Controller, useForm } from 'react-hook-form';
import { formatCoordinates } from '../../helpers';

//Servicios
import { GuiasService, ViniedoService } from '../../services/api';

//Modelos
import NewGuiaModel from '../../models/NewGuia';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import Modal from '../../components/modal/Modal';
import NewGuiaBodega from './NewGuiaBodega';
import ReactDatePicker from 'react-datepicker';

function NewGuiaBodegaContainer() {
    const {
        toast,
        masters,
        localeDateFormat,
        buildSelectOptions,
        formatNumber,
        grapesVariety,
    } = useGlobalContext();

    const Params = useParams();
    const [loader, setLoader] = useState(false);
    const [OpenModal, setOpenModal] = useState(false);
    const [SignedGuia, setSignedGuia] = useState(false);
    const [GrapesVariety, setGrapesVariety] = useState();
    const [Coordinates, setCoordinates] = useState({});
    const [GuiaData, setGuiaData] = useState(new NewGuiaModel());

    const FormMethods = useForm();

    console.log(FormMethods.formState.errors?.cabecera);

    const ModalMessage = useMemo(() => {
        return (
            <div className="new_guia-modal-div">
                <p>
                    Al firmar, la carilla del destinatario de esta guía, ya no
                    podrá ser editada
                </p>
                <label className="new_guia_bodega-label">
                    <div>
                        <span>Fecha de Recepción: </span>
                        <Controller
                            name="cabecera.fecha_Recepcion"
                            control={FormMethods.control}
                            render={() => (
                                <ReactDatePicker
                                    dateFormat={'dd/MM/yyyy'}
                                    isClearable
                                    placeholderText="dd/mm/aaaa"
                                    locale={localeDateFormat}
                                    selected={
                                        FormMethods.getValues(
                                            'cabecera.fecha_Recepcion'
                                        )
                                            ? FormMethods.getValues(
                                                  'cabecera.fecha_Recepcion'
                                              )
                                            : null
                                    }
                                    onChange={(date) => {
                                        FormMethods.setValue(
                                            'cabecera.fecha_Recepcion',
                                            date
                                        );
                                        FormMethods.trigger();
                                    }}
                                />
                            )}
                            rules={{
                                required: {
                                    value: OpenModal,
                                    message: 'Ingrese una fecha de recepción',
                                },
                                validate: {
                                    validDate: (v) =>
                                        new Date(v) <= new Date() ||
                                        'La fecha de recepeción no puede ser mayor a la actual',
                                },
                            }}
                        />
                    </div>
                    {FormMethods.formState.errors.cabecera?.fecha_Recepcion && (
                        <small className="form__error">
                            {
                                FormMethods.formState.errors.cabecera
                                    ?.fecha_Recepcion?.message
                            }
                        </small>
                    )}
                </label>
                <label className="new_guia_bodega-label">
                    <div>
                        <span>Tipo Documento: </span>
                        <select
                            {...FormMethods.register(
                                'cabecera.doc_id_tipo_Destinatario'
                            )}
                        >
                            {buildSelectOptions('DocumentTypes')?.map((op) => {
                                return (
                                    <option key={op.name} value={op.value}>
                                        {op.title}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                    {FormMethods.formState.errors.cabecera
                        ?.doc_id_tipo_Destinatario && (
                        <small className="form__error">
                            {
                                FormMethods.formState.errors.cabecera
                                    ?.doc_id_tipo_Destinatario?.message
                            }
                        </small>
                    )}
                </label>
                <label className="new_guia_bodega-label">
                    <div>
                        <span>Nro de Documento: </span>
                        <input
                            className="signup-input"
                            type="text"
                            {...FormMethods.register(
                                'cabecera.doc_id_Destinatario',
                                {
                                    required: {
                                        value: OpenModal,
                                        message:
                                            'Debe ingresar un documento de identidad',
                                    },
                                }
                            )}
                            onKeyPress={(e) => {
                                if (
                                    !/[A-Za-z0-9]+/.test(e.key) ||
                                    e.target.value.length > 15
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {FormMethods.formState.errors.cabecera
                        ?.doc_id_Destinatario && (
                        <small className="form__error">
                            {
                                FormMethods.formState.errors.cabecera
                                    ?.doc_id_Destinatario?.message
                            }
                        </small>
                    )}
                </label>
                <label className="new_guia_bodega-label">
                    <div>
                        <span>Firma Destinatario: </span>
                        <input
                            type="text"
                            {...FormMethods.register(
                                'cabecera.firma_Destinatario',
                                {
                                    required: {
                                        value: OpenModal,
                                        message: 'Debe firmar la guía',
                                    },
                                }
                            )}
                            onKeyPress={(e) => {
                                if (e.target.value.length > 60) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </div>
                    {FormMethods.formState.errors.cabecera
                        ?.firma_Destinatario && (
                        <small className="form__error">
                            {
                                FormMethods.formState.errors.cabecera
                                    ?.firma_Destinatario?.message
                            }
                        </small>
                    )}
                </label>
                <footer>
                    <button
                        className="btn btn-primary"
                        onClick={FormMethods.handleSubmit(onSubmit)}
                    >
                        Firmar
                    </button>
                    <button
                        className="btn btn-secondary"
                        onClick={() => setOpenModal(false)}
                    >
                        Cancelar
                    </button>
                </footer>
            </div>
        );
    }, [
        OpenModal,
        Object.keys(FormMethods.formState.errors.cabecera ?? {}).length,
    ]);

    //Formateador de coordenadas
    useEffect(() => {
        if (Object.keys(GuiaData).length > 0) {
            formatCoordinates(
                GuiaData.cabecera.ubicacion_Viniedo_x,
                GuiaData.cabecera.ubicacion_Viniedo_y
            ).then((res) =>
                setCoordinates({
                    lat: res[0],
                    lon: res[1],
                })
            );
        }
    }, [GuiaData]);

    useEffect(() => {
        async function fetchGuia() {
            try {
                setLoader(true);
                //Obtenemos la Guia segun el token de los params que viene del link que se le mando al bodeguero en el mail
                const Guia = await GuiasService.single({
                    token: Params.token,
                });
                if (Guia) {
                    //Establecemos los datos para la nueva Guia
                    const NewGuia = new NewGuiaModel({
                        cabecera: Guia.data.cabecera,
                        itemsBodega: Guia.data.itemsBodega,
                        itemsProductor: Guia.data.itemsProductor,
                    });
                    setGuiaData(NewGuia);

                    //Establecemos los valores iniciales del form
                    NewGuia.itemsProductor.forEach((it, i) => {
                        NewGuia.itemsProductor[i][`kilos` + i] = it.kilos;
                        NewGuia.itemsProductor[i][`precio_Kg` + i] =
                            it.precio_Kg;
                    });
                    NewGuia.itemsBodega.forEach((it, i) => {
                        NewGuia.itemsBodega[i][`kilos` + i] = it.kilos;
                        NewGuia.itemsBodega[i][`grado_Gluc` + i] =
                            it.grado_Gluc;
                        NewGuia.itemsBodega[i][`precio_Kg` + i] = it.precio_Kg;
                    });
                    FormMethods.reset({ ...NewGuia });
                }
                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        }
        async function fetchGrapesVariety() {
            try {
                setLoader(true);
                //Obtenemos las variedades de uva que mando el productor
                const VariedadesUvaBodega = await ViniedoService.grapesVariety({
                    token: Params.token,
                });

                if (VariedadesUvaBodega) {
                    setGrapesVariety(VariedadesUvaBodega.data);
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        }

        //Parche para que no se haga una peticion de mas a la api
        if (Object.keys(masters).length) fetchGuia();
        if (Object.keys(masters).length) fetchGrapesVariety();
    }, []);

    //Formamos la tabla con los datos de la bodega
    useEffect(() => {
        setItemsBodegaTableData(
            buildItemsBodegaTableData(GuiaData.itemsBodega)
        );
    }, [GuiaData]);

    async function onSubmit(data) {
        try {
            setLoader(true);

            //Formacion del objeto para enviar en la peticion
            const GuiaUpdated = new NewGuiaModel(data);
            GuiaUpdated.itemsBodega.forEach((it, i) => {
                it.kilos = parseInt(data.itemsBodega[i][`kilos` + i]);
                it.grado_Gluc = parseFloat(
                    data.itemsBodega[i][`grado_Gluc` + i]
                );
                it.precio_Kg = parseInt(
                    GuiaUpdated.itemsBodega[i][`precio_Kg` + i]
                );
                delete GuiaUpdated.itemsBodega[i][`kilos` + i];
                delete GuiaUpdated.itemsBodega[i][`grado_Gluc` + i];
                delete GuiaUpdated.itemsBodega[i][`precio_Kg` + i];
            });
            //Peticion para actualizar la Guia
            const UpdateGuia = await GuiasService.update({
                token: Params.token,
                guia: GuiaUpdated,
            });
            //Si la respuesta es correcta, desplegamos mensaje de éxito
            if (UpdateGuia) {
                toast('Guia enviada con éxito', { type: 'success' });
                setOpenModal(false);
                setSignedGuia(true);
            }
            setLoader(false);
        } catch (err) {
            setLoader(false);
            toast('No se pudo guardar la guía', { type: 'error' });
            return err;
        }
    }

    /**Funcion que crea el objeto para pasarle a la tabla que lista los items de la bodega */
    const buildItemsBodegaTableData = (
        data = [
            { id: 0, variedad: 0, kilos: 0, gradoGlucosa: 0, aproxPrice: 0 },
        ]
    ) => {
        return {
            title: `Uva Recibida`,
            headers: [
                'Variedad de Uva',
                'Kilos en Balanza',
                'Grado de Glucosa',
                'Precio por Kg',
            ],
            pagination: 10,
            data: data?.map((dj, i) => {
                return {
                    variedad: GrapesVariety?.find(
                        (gv) => gv.codigo === dj.variedad
                    )?.variedad,
                    kilos: (
                        <input
                            className="new_guia-table_input"
                            {...FormMethods.register(
                                `itemsBodega[${i}].kilos` + i
                            )}
                            type={'number'}
                            step="any"
                        />
                    ),
                    gradoGlucosa: (
                        <input
                            className="new_guia-table_input"
                            {...FormMethods.register(
                                `itemsBodega[${i}].grado_Gluc` + i
                            )}
                            type={'number'}
                            step="any"
                        />
                    ),
                    aproxPrice: (
                        <input
                            className="new_guia-table_input"
                            {...FormMethods.register(
                                `itemsBodega[${i}].precio_Kg` + i
                            )}
                            type={'number'}
                            step="any"
                        />
                    ),
                };
            }),
        };
    };

    const [ItemsBodegaTableData, setItemsBodegaTableData] = useState(
        buildItemsBodegaTableData()
    );

    return loader ? (
        <Spinner />
    ) : (
        <>
            <NewGuiaBodega
                functions={{
                    ...FormMethods,
                    buildSelectOptions,
                    formatNumber,
                    setOpenModal,
                    onSubmit,
                }}
                states={{
                    ItemsBodegaTableData,
                    SignedGuia,
                    GuiaData,
                    GrapesVariety,
                    Coordinates,
                }}
            />
            <Modal
                title={'Confirmar Guía'}
                isOpen={OpenModal}
                onClose={() => setOpenModal(!OpenModal)}
                questionModal
            >
                {ModalMessage}
            </Modal>
        </>
    );
}

export default NewGuiaBodegaContainer;
